module.exports = __webpack_public_path__ + "static/media/pexels-polina-tankilevitch-3873171-1076x717.83727105.jpeg";